import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CoreModule } from './core/core-module';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { PageSelectorComponent } from './page-selector/page-selector.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LoggingInterceptor } from './core';

@NgModule({
  declarations: [App, PageSelectorComponent],
  imports: [BrowserModule, AppRoutingModule, FontAwesomeModule, CoreModule, NgbToastModule],
  providers: [provideBrowserGlobalErrorListeners(), provideHttpClient(withInterceptorsFromDi()), { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },],
  bootstrap: [App],
})
export class AppModule { }
